import { TableBody, TableHead, TableRow } from "@mui/material";
import { StyledTable, StyledTableCell, TableContainer } from "../CustomTable/Styled";
import { formatNumber } from "../../../utils/format";
import { StockCard, StockCardTransaction } from "./types";
import dayjs from "dayjs";

interface StockCardPreviewProps {
    cards: StockCard[];
}

const quantity = (value: number | null | undefined) =>
    value === null || value === undefined ? "" : formatNumber(value);

const documentHref = (transaction: StockCardTransaction): string | null => {
    if (!transaction.document_id) {
        return transaction.document_url?.startsWith("/") && !transaction.document_url.startsWith("//")
            ? transaction.document_url
            : null;
    }
    const id = encodeURIComponent(transaction.document_id);
    switch (transaction.document_type) {
        case "product_order":
            return `/product-orders/${id}`;
        case "material_import":
            return `/materials/?tab=material-import-history#preview=${id}`;
        case "material_export":
            return `/materials/?tab=material-export-history#preview=${id}`;
        case "product_import":
            return `/products/?tab=product-import-history#preview=${id}`;
        case "product_export":
            return `/products/?tab=product-export-history#preview=${id}`;
        default:
            return null;
    }
};

const StockCardPreview = ({ cards }: StockCardPreviewProps) => (
    <div data-testid="stock-card-table-preview">
        {cards.map((card) => (
            <section key={card.id} style={{ marginBottom: 20}}>
                <div style={{ margin: "0 0 8px", fontSize: 13, fontWeight: 700 }}>
                    {card.item_code} · {card.name} . {card.measurement_unit}
                    {card.storage ? ` · ${card.storage}` : ""}
                </div>
                <TableContainer style={{ maxHeight: "none" }}>
                    <StyledTable size="small" aria-label={`Thẻ kho ${card.name}`}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Ngày</StyledTableCell>
                                <StyledTableCell>Số chứng từ</StyledTableCell>
                                <StyledTableCell>Diễn giải</StyledTableCell>
                                <StyledTableCell align="right">Nhập</StyledTableCell>
                                <StyledTableCell align="right">Xuất</StyledTableCell>
                                <StyledTableCell align="right">Tồn</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <StyledTableCell colSpan={5}>Tồn đầu kỳ</StyledTableCell>
                                <StyledTableCell align="right">
                                    {quantity(card.opening_quantity)}
                                </StyledTableCell>
                            </TableRow>
                            {card.transactions.map((transaction) => (
                                <TableRow key={transaction.id}>
                                    <StyledTableCell>
                                        {transaction.date ? dayjs(transaction.date).format("DD/MM/YYYY") : ""}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {documentHref(transaction) && transaction.document_number ? (
                                            <a
                                                href={documentHref(transaction) || undefined}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {transaction.document_number}
                                            </a>
                                        ) : (
                                            transaction.document_number || ""
                                        )}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {transaction.description || ""}
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        {quantity(transaction.imported_quantity)}
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        {quantity(transaction.exported_quantity)}
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        {quantity(transaction.running_quantity)}
                                    </StyledTableCell>
                                </TableRow>
                            ))}
                            <TableRow>
                                <StyledTableCell colSpan={3}>Cộng cuối kỳ</StyledTableCell>
                                <StyledTableCell align="right">
                                    {quantity(card.total_imported)}
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                    {quantity(card.total_exported)}
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                    {quantity(card.closing_quantity)}
                                </StyledTableCell>
                            </TableRow>
                        </TableBody>
                    </StyledTable>
                </TableContainer>
            </section>
        ))}
    </div>
);

export default StockCardPreview;
